import { useEffect, useState } from 'react';

export const usePagination = (totalCount: number) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalRowsCount, setTotalRowsCount] = useState(0);

  useEffect(() => {
    setTotalRowsCount(totalCount);
  }, [totalCount]);

  const change = (page: number, pageSize: number) => {
    setRowsPerPage(pageSize);
    setPageNumber(pageSize === rowsPerPage ? page : 1);
  };

  return {
    pageNumber,
    rowsPerPage,
    totalRowsCount,
    change,
  };
};
